import { render, staticRenderFns } from "./component-title.vue?vue&type=template&id=c140b298&"
import script from "./component-title.vue?vue&type=script&lang=js&"
export * from "./component-title.vue?vue&type=script&lang=js&"
import style0 from "./component-title.vue?vue&type=style&index=0&id=c140b298&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports